import isEqual from 'lodash/isEqual';
import { isString } from '@cutwise/utils';

import { ASC, DESC } from '@/common/constants/sort';
import { SortDirection } from '@/common/types/sort';

export default class Sort {
  sortFields: { field: string; direction: SortDirection }[] = [];

  constructor() {
    this.sortFields = [];
  }

  static get DIRECTION_ASC() {
    return ASC;
  }

  static get DIRECTION_DESC() {
    return DESC;
  }

  static get SORT_MEDIA_RELEVANCE() {
    return 'mediaRelevance';
  }

  static get SORT_MANUAL() {
    return 'manual';
  }

  static get DEFAULT_SORT() {
    return Sort.SORT_MEDIA_RELEVANCE;
  }

  // TODO remove, transform duplicate
  static decode(transformedSort: Record<string, string>) {
    if (!transformedSort) {
      return null;
    }

    const decodedField = Object.keys(transformedSort)[0];
    const decodedDirection = transformedSort[decodedField];

    return { field: decodedField, direction: decodedDirection };
  }

  static fromJSON(orderByFromServer: Record<string, SortDirection>) {
    const sort = new Sort();

    Object.keys(orderByFromServer).forEach((sortField) => sort.addMultiSort(sortField, orderByFromServer[sortField]));

    return sort;
  }

  static makeManual() {
    return new Sort().setSingleSort(Sort.SORT_MANUAL, Sort.DIRECTION_DESC);
  }

  setSingleSort(field: string, direction?: SortDirection) {
    if (isString(field) && field && direction && [ASC, DESC].includes(direction)) {
      this.sortFields = [{ field, direction }];
    }

    return this;
  }

  getSortDirection(fieldName: string) {
    const sortField = this.getFieldByName(fieldName);

    return sortField ? sortField.direction : Sort.DIRECTION_DESC;
  }

  getFieldByName(fieldName: string) {
    return this.sortFields.find((sortItem) => sortItem.field === fieldName);
  }

  addMultiSort(field: string, direction: SortDirection) {
    this.sortFields.push({ field, direction });

    return this;
  }

  getFirstField() {
    return this.sortFields && this.sortFields.length > 0 ? this.sortFields[0].field : null;
  }

  hasField(fieldName: string) {
    return !!this.getFieldByName(fieldName);
  }

  transform() {
    const transformedSort: Record<string, SortDirection> = {};

    this.sortFields.forEach((sort) => {
      transformedSort[sort.field] = sort.direction;
    });

    return transformedSort;
  }

  isEqual(object: Nullable<Sort>) {
    if (!object) {
      return false;
    }

    const transformedThis = this.transform();
    const transformedObject = object.transform();

    return isEqual(transformedThis, transformedObject);
  }
}
